import { Component } from "react";
import Popup from "..";
import RectButton from "../../ui/button/RectButton";
import Calendar from "../../ui/Calendar";
import Input from "../../ui/Input";
import Select from "../../ui/Select";
import Option from "../../ui/Select/Option";

class AddNewRecipientPopup extends Component {
    render() {
        return (
            <Popup className="add-new-recipient-popup">
                <h3>{this.props.edit ? "Edit Recipient" : "Add New Recipient"}</h3>
                <div className="column">
                    <div className="row">
                        <Input placeHolder="First Name" />
                        <Input placeHolder="Last Name" />
                    </div>
                    <Input placeHolder="Griflan Design, Inc." />
                    <Input placeHolder="4206 Spruce Street" />
                    <Input placeHolder="Address 2 (Optional)" />
                    <div className="row">
                        <Input placeHolder="Philadelphia" />
                        <Select>
                            <Option>PA</Option>
                        </Select>
                        <Input placeHolder="19104" />
                    </div>
                    <Select>
                        <Option>United States</Option>
                    </Select>
                    <Calendar hint="Birthday" />
                    <RectButton text="SAVE RECIPIENT" />
                </div>
            </Popup>
        )
    }
}

export default AddNewRecipientPopup;